import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Cards1Props } from '../Cards1';
import { BLOCKS } from "@contentful/rich-text-types";

function cards1Adapter(data: any): Cards1Props {
  return {
    title: data.tituloGeneral ?? '',
    cards: data?.referenciaPlantillaContenido?.map((card: any) => ({
        iconoCard: card.tituloDescripcion,
        title: card.tituloBanner,
        tituloBoton: card.tituloBoton,
        urlBoton: card.redireccionBoton,
        text: card.descripcion ? documentToReactComponents(JSON.parse(card.descripcion.raw)
            ,
            {
              renderNode:{
                [BLOCKS.PARAGRAPH]: (node: any, children: React.ReactNode) => children
              }
            }
            
          ) : [],
    })) ?? ''
  };
}

export default cards1Adapter;
